import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';

import AccountDetails from './account/AccountDetails';
import MyOrders from './account/MyOrders';
import ClubInformation from './account/ClubInformation';
import EditProfile from './account/EditProfile';
import EditAddressBook from './account/EditAddressBook';
import EditPayment from './account/EditPayment';
import { connect } from 'react-redux';

import Layout from '../ui/Layout';
import { bindActionCreators } from 'redux';
import fetchDux from '../../state/fetch-dux';
import queryString from 'query-string';

class AccountRoutes extends Component {
  componentDidMount() {
    this.props.validateLogin();
  }
  render() {
    const { match, error, location: { pathname, search } } = this.props;
    const { url } = match || {};
    if (error) {
      if (pathname !== '/account/club-information/') {
        return <Redirect to="/shop" />
      }
      else if (pathname === '/account/club-information/') {
        const { waitlist } = queryString.parse(search) || {};
        if (waitlist) {
          return <Redirect to={`/account/login${search}`} />;
        } else {
          return <Redirect to="/shop" />;
        }
      }
    }
    return (
      <Layout>
        <Switch>
          <Route exact path={`${url}`} component={AccountDetails} />
          <Route path={`${url}/my-orders`} component={MyOrders} />
          <Route path={`${url}/club-information`} component={ClubInformation} />
          <Route
            path={`${url}/edit-profile/address-book/:id`}
            component={EditAddressBook}
          />
          <Route
            path={`${url}/edit-profile/payment/:id`}
            component={EditPayment}
          />
          <Route path={`${url}/edit-profile/:page?`} component={EditProfile} />
          <Redirect to={url} />
        </Switch>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error
  } = state.validateLogin.toJS();
  return {
    error
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      validateLogin: fetchDux.validateLogin.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(AccountRoutes);
